package com.essntl.features.request.ui.addeditrequest.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.features.request.ui.allrequest.components.RequestStatusDropDown
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme

@Composable
fun AddEditRequestHeader(
    request: RequestModel?,
    onEditRequestStatus: (requestId: String, status: RequestModel.Status) -> Unit,
    enabled: Boolean,
    isLoading: Boolean,
    modifier: Modifier = Modifier,
) {
    Column(
        horizontalAlignment = Alignment.Start,
        verticalArrangement = Arrangement.spacedBy(1.5f.spacing),
        modifier = modifier
            .fillMaxWidth()
            .clip(
                RoundedCornerShape(
                    bottomStart = 24.dp,
                    bottomEnd = 24.dp,
                ),
            )
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                top = 1.5f.spacing,
                bottom = 2.5f.spacing,
            )
            .padding(
                horizontal = 2.5f.spacing,
            ),
    ) {
        if (request != null) {
            RequestStatusDropDown(
                status = request.status ?: RequestModel.Status.Pending,
                enabled = enabled && !isLoading &&
                    request.status != RequestModel.Status.Pending,
                onStatusSelected = { newStatus ->
                    if (newStatus != request.status) {
                        onEditRequestStatus(request.id, newStatus)
                    }
                },
            )
        }
    }
}